import { HTTP } from '../../utils'

export const getIndividualCoacheeStatus = () => {
  return HTTP().get('competency/coacheestatus')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCoacheeStatus = () => {
  return HTTP().get('competency/allcoacheestatus')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCoacheesCareerIdeas = () => {
  return HTTP().get('careerIdea/allcoachees')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const assignCoachCoachee = (coachId, coacheeId) => {
  return HTTP().put('clearynext/coach/' + coachId + '/coachee/' + coacheeId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const saveNote = (note) => {
  return HTTP().put('clearynext/saveNote', note)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getNote = (coacheeId, type) => {
  return HTTP().get('clearynext/getNote/' + coacheeId + '/' + type)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}



// WEBPACK FOOTER //
// ./src/app/coacheeTracker/api.js